import { Partial } from '@40seas/entities/common';
import { CreateConnectedAccountDto } from './create.connected-account.dto';

export class UpdateConnectedAccountDto extends Partial(CreateConnectedAccountDto) {}
